import { cn } from '@tempo-io/sui-class-utils';
import type { ComponentProps } from 'react';

export function CardDate({
  isCompact = false,
  className,
  ...props
}: ComponentProps<'span'> & { isCompact?: boolean }) {
  return (
    <span
      className={cn(
        'text-xs font-normal leading-3 text-text-neutral-secondary',
        isCompact ? 'mt-[6px]' : 'mt-[2px]',
        className,
      )}
      {...props}
    />
  );
}

export function CardDescription({
  isCompact,
  className,
  ...props
}: ComponentProps<'p'> & { isCompact?: boolean }) {
  return (
    <p
      className={cn(
        'overflow-hidden text-xs leading-[18px] text-text-neutral-primary',
        '[display:-webkit-box] [-webkit-box-orient:vertical] [box-orient:vertical]',
        '[-webkit-line-clamp:3] [line-clamp:3]',
        isCompact ? 'pt-[6px]' : 'pt-[8px]',
        className,
      )}
      {...props}
    />
  );
}
